const config = {
    graphql: {
        uri:
            process.env.REACT_APP_GRAPHQL_URI ||
            'http://localhost:4000/graphql',
    },

    calendly: {
        url:
            process.env.REACT_APP_CALENDLY_URL ||
            'https://calendly.com/kileen-valenzuela',
    },

    api: {
        uri: process.env.REACT_APP_API_URI || 'http://localhost:4000/api',
    },

    searchResultsPageSize: 25,
}

export default config
